<div fxLayout="column">
  <div fxLayout="row">
    <h2 fxFlex="100">Δημιουργία γραμμής</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    Πλήθος στηλών:
    &nbsp;
    <mat-form-field appearence="legacy">
      <input type="number" matInput [(ngModel)]="numberOfColumns">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-flat-button (click)="createRow()">Δημιουργία</button>
  </div>
</div>
